import { render, staticRenderFns } from "./DefaultCoin.vue?vue&type=template&id=5f08fb76&"
import script from "./DefaultCoin.vue?vue&type=script&lang=ts&"
export * from "./DefaultCoin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports